import vSelect from 'vue-select';
import { ValidationMessage, ValidatedInput, FormLabel } from "@/app/shared/components";
import ShiftEnum from "./../../../shared/ShiftEnum.js";

export default {
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    isNewEmployeePrompt: {
      type: Boolean,
      default: false
    },
    employeeEntry: {
      type: Object,
      default: null
    },
    listEmployees: {
      type: Array,
      required: true,
      default: []
    },
    newlyCreatedEmployee: {
      type: Object,
      default: null
    },
    jobEntries: {
      type: Array,
      required: true,
      default: []
    }
  },
  components: {
    vSelect,
    ValidationMessage,
    ValidatedInput,
    FormLabel
  },
  data () {
    return {
      model: this.createModel(),
      isPopupActive: this.$props.isActive,
      shifts: ShiftEnum.definition,
      isValid: false,
      isDuplicateEntry: false,
      unmodifiedEntry: null
    };
  },
  watch: {
    isActive(newVal) {
      this.isPopupActive = newVal;
    },
    isPopupActive(newVal) {
      if (newVal === false) this.$emit('closeEmployeePopup', newVal);
      if (newVal && !this.isNewEmployeePrompt) {
        this.model = structuredClone(this.employeeEntry);
      }
    },
    employeeEntry(newVal) {
      if (!newVal) return;
      if (newVal) this.model = structuredClone(newVal);
      else this.model = {};
      this.unmodifiedEntry = structuredClone(this.model);
    },
    newlyCreatedEmployee() {
      if (this.employees.find(_ => _.id === this.newlyCreatedEmployee.id) !== undefined)
        this.model.employeeId = this.newlyCreatedEmployee.id;
    },
    'model.employeeId'() {
      this.isValid = this.validatePopup();
    },
    'model.shift'() {
      this.isValid = this.validatePopup();
    },
    'model.employeeTitleId'() {
      this.isValid = this.validatePopup();
    }
  },
  mounted() {
  },
  computed: {
    employeeTitles() {
      return this.$store.state.drilling.employeeTitles;
    },
    employeePromptTitle() {
      return this.isNewEmployeePrompt ? this.$t('Drilling.JobEntries.AddTimeEntry') : this.$t('Drilling.JobEntries.EditTimeEntry');
    },
    localizedName() {
      return this.$i18n.locale.startsWith('fr') ? "nameFr" : "nameEn";
    },
    employees() {
      return this.listEmployees.filter(_ => _.isActive).map(e => ({ ...e, fullName: e.firstName + ' ' + e.lastName }));
    }
  },
  methods: {
    submitEmployee() {
      const clonedModel = structuredClone(this.model);
      if (clonedModel.employeeId !== null && clonedModel.employeeId !== undefined) {
        const employee = this.employees.find(_ => _.id === clonedModel.employeeId);
        clonedModel.employeeName = employee.firstName + ' ' + employee.lastName;
      }
      if (clonedModel.employeeTitleId !== null && clonedModel.employeeTitleId !== undefined) {
        const employeeTitle = this.employeeTitles.find(_ => _.id === clonedModel.employeeTitleId);
        clonedModel.title = employeeTitle[this.localizedName];
      }
      this.$emit('submit', clonedModel);
    },
    getSelectedEmployeeName() {
      return this.model.employee.firstName + ' ' + this.model.employee.lastName;
    },
    addEmployee() {
      this.$emit('addEmployee');
    },
    reinitComponent() {
      this.model = this.createModel();
      this.shifts = ShiftEnum.definition;
      this.unmodifiedEntry = this.createModel();
    },
    getEmployeeName(e) {
      return e.firstName + ' ' + e.lastName;
    },
    createModel() {
      return {
        hours:[],
        shift: 0,
        title: null,
        employeeId: null,
        employeeTitleId: null,
        note: null,
        employeeName: null
      }
    },
    validatePopup() {
      const isValid = this.model.employeeId !== null && 
                      this.model.employeeId !== undefined && 
                      this.model.employeeTitleId !== null;
      let indexOfunmodifiedEntry = -1;
      if (this.unmodifiedEntry) 
        indexOfunmodifiedEntry = this.getIndex(this.unmodifiedEntry);
      const indexOfModifiedEntry = this.getIndex(this.model);
      this.isDuplicateEntry = indexOfModifiedEntry >= 0 && indexOfModifiedEntry !== indexOfunmodifiedEntry;
      return isValid && !this.isDuplicateEntry;
    },
    getIndex(employee) {
      const uniqueId = employee.employeeId + '-' + employee.employeeTitleId + '-' + employee.shift;
      return this.jobEntries.findIndex(_ => _.rowId === uniqueId);
    }
  },
  emits: ['submit', 'closeEmployeePopup', 'addEmployee']
}
